export default __webpack_public_path__ + "static/media/printed.25b71cec.svg";